export interface NavigationState {
  initialPath: string | null;
  init: boolean;
}

export const navigationInitialState: NavigationState = {
  initialPath: null,
  init: true,
};
